import React from 'react';
import { SuccessScene } from '../../components/SuccessScene';

export const ForgotSuccessScene = () => <SuccessScene context="ForgotSuccessScene" />;
